// @vendors
import {createContext, useEffect, useMemo} from 'react';
import { useSelector } from 'react-redux';

// @styles
import { StyleAPiClient } from './StyleApiClient.js';

// @components
import {
  Box,
  Container,
  Typography,
} from "../../components/shared/MaterialUI.js";
import TableApiClient from './TableApiClient.js';

// @hooks
import useClients from './hooks/UseClients.js';
import { theme } from '../../assets/theme.js';

const ApiClients = () => {
  const styles = useMemo(() => StyleAPiClient(), []);
  const state = useSelector((loadedState) => loadedState);
  const organizationId = state?.organizationReducer?.organizationSelected?.id;

  const {
    rowsState,
    getAllClients,
    setRowsState,
  } = useClients(organizationId);
  
  useEffect(() => {
    getAllClients();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationId])

  return (
    <Container
      component="section"
      maxWidth="xl"
      sx={styles.containerApiClient}
    >
      <Box sx={styles.header}>
        <Typography sx={{
          fontSize: { xs: "20px", md: "28px" },
          fontWeight: "bold",
          color: theme.palette.primary.black
        }}
        >Api Clients</Typography>
      </Box>

      <ClientContext.Provider
        value={{
          rowsState,
          getAllClients,
          setRowsState
        }}
      >
        <TableApiClient />
      </ClientContext.Provider>
    </Container>
  )
}

export const ClientContext = createContext({});
export default ApiClients